import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import Switch from "react-switch"
import PreviewTemplateModal from "./PreviewModal";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardDeck,
  CardFooter,
  CardHeader,
  CardImg,
  CardImgOverlay,
  CardText,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  Badge,
  ModalHeader,
  ModalBody
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import TemplateSidebar from "components/VerticalLayout/TemplateSidebar";
import * as Yup from "yup";
import { getAllTemplates } from "../../store/templates/actions";
import axios from "axios"
import Swal from "sweetalert2";
import { API_URL } from "helpers/app_url";
class OurTemplates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tempTypes:[],
      template: "",
      viewmodal: false,
      modal: false,
    }

    this.handleTemplateClicks = this.handleTemplateClicks.bind(this)
    this.toggle = this.toggle.bind(this);
  }
  

  
  componentDidMount() {
    this.fetchTemplates();
}
componentDidUpdate(prevProps, prevState, snapshot) {
  const { templates } = this.props;
  if (!isEmpty(templates) && size(prevProps.templates) !== size(templates)) {
    this.setState({ templates: {}, isEdit: false });
  }
}

toggle() {
  this.setState(prevState => ({
    modal: !prevState.modal,
  }));
}

handleTemplateClicks = () => {
  this.setState({ template: "", isEdit: false });
  this.toggle();
};

 getTemplateType = (type) => {
    if (type == 1)
      return 'Pre-Construction Project';
    else if (type == 2)
      return 'Newsletters';
    else if (type == 6)
      return 'Seller Pages';
    else if (type == 7)
      return 'Assignment Sales';

  }
 fetchTemplates = () => {
        const authUser = localStorage.getItem("authUser");
        if (!authUser) return;
        const obj = JSON.parse(authUser);
        const token = obj?.resultData?.bearerToken;
        if (!token) return;
        const str = 'Bearer ' + token;
        axios.get(`${API_URL}ProjectEmailTemplate/alltemplates`, {
            params: { agentId: parseInt(localStorage.getItem("userId")) },
            headers: { Authorization: str }
        })
        .then(res => this.setState({ templates: res.data }))
        .catch(err => console.error("Error fetching templates:", err));
    }
 deleteTemplate = (templateId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const authUser = localStorage.getItem("authUser");
                if (!authUser) return;
    
                const obj = JSON.parse(authUser);
                const token = obj?.resultData?.bearerToken;
                if (!token) return;
    
                const str = 'Bearer ' + token;
    
                axios.delete(`https://rscoreapi.azurewebsites.net/api/ProjectEmailTemplate/${templateId}`, {
                    headers: { Authorization: str }
                })
                .then(() => {
                    this.setState(prevState => ({
                        templates: prevState.templates.filter(template => template.id !== templateId)
                    }));
                    
                    // Show success message
                    Swal.fire("Deleted!", "The template has been deleted.", "success");
                })
                .catch(err => {
                    console.error("Error deleting template:", err);
                    Swal.fire("Error!", "Failed to delete the template.", "error");
                });
            }
        });
    }
handleTemplateClicks = arg => {
  const template = arg;
  this.setState(prevState => ({
    viewmodal: !prevState.viewmodal,
  }));
  this.setState({
    template: {
      id: template.id,
      uiTemplateId: template.uiTemplateId,
      agentId: template.agentId,
      templateTitle: template.templateTitle,
      templateContent: template.templateContent,
      templateType: template.templateType,
      publishStatusId: template.publishStatusId,
      templateDescription: template.templateDescription,
      templateCSS: template.templateCSS,
      templateJS:template.templateJS,
      isActive:template.isActive
    },
    isEdit: true,
  });
  
  this.toggle();
};
render() {
  const { templates } = this.state;
  const template = this.state.template;
  //
    return (
      <React.Fragment>
       
          <PreviewTemplateModal
          isOpen={this.state.viewmodal}
          toggle={this.handleTemplateClicks}
          data={template}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>All Templates | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
           
          <Row>
              <Col  sm='3' className="pe-0">
              <TemplateSidebar  />

          
            </Col>
            <Col sm="9">
            <Row className="project-header">
            <Col xl="12">
             <Breadcrumbs
              title={this.props.t("Templates")}
              breadcrumbItem={this.props.t("All Templates")}
            />
           
            </Col>
           
            </Row>
            <Row>

              
              <Col lg="12">
             
             

  
             
             <Row>
            {map(templates, (template, templatekey) => (
            <Col lg={4} key={templatekey}>
              <Card style={{marginBottom:20}} className={"tempData tempData" + template.templateType }>
             
                <CardBody>
                  <CardTitle className="mt-0">{template.templateTitle}</CardTitle>
                  <CardText style={{fontSize:20}}>{this.getTemplateType(template.templateType)}</CardText>
                    
                  
                 
                </CardBody>
                  <div className="card-footer">
                                                            { <Link  onClick={() => this.handleTemplateClicks(template)} className="previewClass card-link float-left tempLink">View</Link>}
                
                                                        <Link to="#" onClick={() => this.deleteTemplate(template.id)} className="previewClass card-link float-end tempLink">Delete</Link>
                                                    </div>
               
              </Card>
            </Col>
             ))}
           
            </Row>



 
            
            </Col>
            
            </Row>
            </Col>
            </Row>
        
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
OurTemplates.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  loading: PropTypes.object,
  templates:PropTypes.array,
  onGetAllTemplates:PropTypes.func,

 

}
const mapStateToProps = ({Template}) => (
  {
    
    templates: Template.templates,
    loading: Template.loading

  })
const mapDispatchToProps = dispatch => ({
  
    onGetAllTemplates : (agentId) => dispatch(getAllTemplates(agentId))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OurTemplates))
